export default __webpack_public_path__ + "static/media/comment-emote-shock.fc950c14.svg";